import React from 'react';
import styled from 'styled-components';

const MaxusFooter = () => {
  return (
    <Footer>
      <FooterTop />
      <FooterBottom>
        <LineContainer>
          <Hr />
        </LineContainer>
        <TextContainer>
          <CopyRight>&copy; 2021 Eir Försäkring AB</CopyRight>
          <Contact>
            Försäkringsgivare:
            <br />
            Eir Försäkring AB. Org. 559166-0617
            <br />
            BOX 3132, 103 62 Stockholm
            <br />
            <A href='mailto:info@eirforsakring.se'>info@eirforsakring.se</A>
          </Contact>
        </TextContainer>
      </FooterBottom>
    </Footer>
  );
};

export default MaxusFooter;

const Footer = styled.footer``;

const FooterTop = styled.div`
  width: 100%;
  min-height: 10vh;
  background-color: #9faef4;
`;

const FooterBottom = styled.div`
  margin: auto;
  max-width: 1400px;
`;

const LineContainer = styled.div`
  width: 100%;
  padding: 1.6rem;
`;

const Hr = styled.hr`
  height: 0.1rem;
  border: none;
  background-color: #0a0a0a;
`;

const TextContainer = styled.div`
  display: flex;
  line-height: 1.8;
  font-size: 1.44rem;
  padding: 1.6rem;
`;

const CopyRight = styled.div`
  flex: 1;
`;

const Contact = styled.div``;

const A = styled.a`
  color: #2b387e;
  background-repeat: repeat-x;
  background-image: linear-gradient(
    to right,
    currentColor 100%,
    currentColor 0
  );
  background-size: 1px 1px;
  background-position: 0 100%;
  white-space: initial;
`;
